import { EntityBase } from 'projects/sepidz-web-framework/src/lib/models/entity-base.model';
import { Invoice, InvoiceMode } from '../../order/model/invoice.model';

export class Salon extends EntityBase {
  public Title: string;
  public BranchId:number;
  public Tables: Table[];
  public TableReads: TableRead[];
  public Selected: boolean;
  public IsActive: boolean;
  public Illegal: boolean;
}

export class Table extends EntityBase {
  public Title: string;
  public Code: number;
  public IsActive: boolean;
  public SalonId: number;
}

export class TableRead {
  public Id: number;
  public Title: string;
  public SalonTitle: string;
  public Code: number;
  public IsActive: boolean;
  public SalonId?:number;
  public InvoiceId: number;
  //public Invoice: Invoice;
  public InvoiceTotal: number;
  public CustomerName: string;
  //public CustomerId: number;
  public NumberOfGuests: number;
  public Status: TableStatus;
  public RelativeInvoiceTime?: Date;
  public RelativeInvoiceTimeString: string;
  public Locked: boolean;
  public MaximumTimeForStay: number;
  public SaleMethodBranchId: number;
  public SaleMethodTitle: string;
  public InvoiceStatusCode: number;
  constructor() {
    this.Title = '';
    this.SalonTitle = '';
    this.Code = 0;
    this.IsActive = false;
    this.InvoiceId = 0;
    this.InvoiceTotal = 0;
    this.CustomerName = '';
    //this.CustomerId = 0;
    this.NumberOfGuests = 0;
    this.Status = TableStatus.Free;
    this.RelativeInvoiceTime = new Date();
    this.RelativeInvoiceTimeString = '';
    this.Locked = false;
  }
}

export enum TableStatus {
  Free = 1,
  Ordering = 2,
  Clearing = 3,
  TimeOver = 4
}
